var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tariff-info-wrapper"},[_c('TariffCard',{staticClass:"hide-mobile",attrs:{"tariff":_vm.bookedTariff}}),_c('TariffCardCompact',{staticClass:"hide-desktop",attrs:{"tariff":_vm.bookedTariff}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }